import { Link } from 'react-router-dom';

const documentAccessors = formatMessage => ({
  title: document => (
    <Link to={`/document-management/${document.id}`}>{document.title}</Link>
  ),
  languageCodes: document =>
    `${document.languageCodes.join(', ')} (${document.languageCodes.length})`,
  appVersion: document => document.appVersion,
  category: document => document.category,
  companyType: document =>
    formatMessage(
      {
        SERVICE_ADMINISTRATOR: {
          id: 'SERVICE_ADMINISTRATOR',
          defaultMessage: 'Service Administrator',
        },
        SERVICE_PROVIDER: {
          id: 'SERVICE_PROVIDER',
          defaultMessage: 'Service Provider',
        },
      }[document.companyType] || {
        id: 'ALL',
        defaultMessage: 'All',
      },
    ),
  status: document =>
    formatMessage(
      document.status === 'ACTIVE'
        ? {
            id: 'ACTIVE',
            defaultMessage: 'Active',
          }
        : {
            id: 'INACTIVE',
            defaultMessage: 'Inactive',
          },
    ),
  lastModifiedDateTime: document =>
    document.lastModifiedDateTime
      ? new Date(document.lastModifiedDateTime).toLocaleString()
      : '',
});

export default documentAccessors;
